import AppComponent from "./AppComponent";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";

const history = createBrowserHistory();

function App() {
  return (
    <div className="App">
      <Router history={history}>
        <AppComponent />
      </Router>
    </div>
  );
}

export default App;
